var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('AnalyticsCharts',{key:"officerMap",attrs:{"loaded":_vm.loaded,"officers":_vm.officers,"roles":_vm.roles,"orders":_vm.orders,"order-types":_vm.orderTypes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }